import { createContext } from 'react';
const formContext = /*#__PURE__*/createContext({
  errorMessages: {},
  fields: {},
  onUpdate: () => ({}),
  reset: () => ({}),
  hasErrors: false,
  values: {}
});
export { formContext };